import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M14.73 1.317a1 1 0 0 0-1.28.112l-.708.707 2.121 2.121.708-.707a1 1 0 0 0 0-1.414l-.707-.707a1.006 1.006 0 0 0-.134-.112Zm-2.695 1.526 2.122 2.122L10.62 8.5 8.499 6.38l3.536-3.536Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m1.782 14.51 1.06-1.06a1 1 0 0 1 0-1.414l4.95-4.95 2.122 2.121-4.95 4.95a1 1 0 0 1-1.414 0l-1.06 1.06a.5.5 0 0 1-.708-.707ZM7.44 9.56a.5.5 0 0 0-.707 0L4.61 11.683a.5.5 0 0 0 .707.707l2.121-2.121a.5.5 0 0 0 0-.707Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  a
];
function c(r, s) {
  return t(), l("svg", o, [...d]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
